export default __webpack_public_path__ + "static/media/instaquiz.d4f61d47.svg";